<div *ngIf="camposOpcionales" class="my-3">
  <div
    *ngFor="let column of columnas; let i = index"
    class="form-c__column--titleheck form-check-inline">
    <label class="font-weight-bold"
      >{{ column.title }}
      <input
        class="form-check-input"
        type="checkbox"
        [checked]="column.visible || column.visible === undefined"
        (change)="cambiarVisibilidad($event, i)" />
    </label>
  </div>
</div>

<div class="table__styles">
  <div class="col-12 col-xl-2 mb-3">
    <span *ngIf="paginacion" class="label-registros-por-pagina">{{"comun-label.registros-por-pagina" | translate}}</span>
    <select
      class="form-select select-custom"
      type="number"
      (change)="selectPage(1)"
      [(ngModel)]="tamano"
      *ngIf="paginacion"
      title="Select Paginacion"
      id="paginationSelect">
      <option *ngFor="let item of tamanos" [value]="item">{{ item }}</option>
    </select>
  </div>
  <div class="tabla-govco" [style]="estilosAdicionales">
    <table
      class="table table-hover table-striped"
      aria-describedby="tableDescAccented">
      <thead class="encabezado-tabla">
        <tr id="filtro" [style]="estiloEncabezado">
          <th class="text-center" *ngIf="multipleSelection">
            <input
              type="checkbox"
              [checked]="isAllSelected()"
              (change)="toggleAllSelection($event)" />
          </th>
          <th
            class="text-start"
            *ngFor="let column of columnasVisibles()"
            [id]="column.id ? column.id : column.field"
            [style]="{
              width: column.width || 'fit-content',
              height: 'inherit',
            }">
            <div
              class="table__styles__column--height d-flex flex-row justify-content-center align-items-start"
              [style]="{ width: column.width || '100%' }">
              <div
                class="table__styles__column--height flex-grow-1 d-flex flex-column justify-content-between">
                <p
                  class="m-0 text2-tipografia-govco table__styles__column--title">
                  {{ column.title }}
                </p>
                <div *ngIf="column.filterable">
                  <input
                    type="text"
                    class="form-control select-custom"
                    [(ngModel)]="
                      filtros[column.fieldFilterElement || column.field]
                    "
                    (change)="filtrar()"
                    *ngIf="column.type === 'text' || column.type === 'html'" />
                  <!-- <p-calendar
                    *ngIf="column.type === 'date'"
                    [(ngModel)]="
                      filtros[column.fieldFilterElement || column.field]
                    "
                    dateFormat="dd/mm/yy"
                    placeholder="dd/mm/aaaa"
                    [showIcon]="true"
                    [iconDisplay]="'input'"
                    (onSelect)="filtrar()"
                    (onClear)="filtrar()"
                    [showClear]="true"
                    appendTo="body"></p-calendar> -->
                  <input
                    *ngIf="column.type === 'date'"
                    class="form-control"
                    type="date"
                    [(ngModel)]="
                      filtros[column.fieldFilterElement || column.field]
                    "
                    placeholder="dd/mm/aaaa"
                    (change)="filtrar()" />
                  <input
                    type="number"
                    class="form-control select-custom"
                    [(ngModel)]="
                      filtros[column.fieldFilterElement || column.field]
                    "
                    (change)="filtrar()"
                    *ngIf="column.type === 'number'" />
                  <select
                    class="form-select select-custom"
                    *ngIf="column.type === 'select'"
                    [(ngModel)]="
                      filtros[column.fieldFilterElement || column.field]
                    "
                    (change)="filtrar()">
                    <option [value]="undefined" selected>
                      {{ 'seleccione' | translate }}
                    </option>
                    <option
                      *ngFor="let item of column.elements"
                      [value]="item[column.value || 'id']"
                      [title]="item[column.option || 'nombre']">
                      {{ item[column.option || 'nombre'] }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="d-flex flex-column justify-content-start mx-2"
                *ngIf="column.sortable">
                <button
                  href=""
                  class="btn btnArrowTable hvr-shrink m-0 p-0"
                  (click)="
                    ordenar(column.fieldFilterElement || column.field, false)
                  "
                  aria-label="Ordenar ascendente">
                  <i class="fa fa-angle-up fa-lg"></i>
                </button>
                <button
                  href=""
                  class="btn btnArrowTable hvr-shrink m-0 p-0"
                  (click)="
                    ordenar(column.fieldFilterElement || column.field, true)
                  "
                  aria-label="Ordenar descendente">
                  <i class="fa fa-angle-down fa-lg"></i>
                </button>
              </div>
            </div>
          </th>
          <th
            style="width: fit-content"
            class="text-center"
            *ngIf="acciones.length > 0">
            <p class="m-0 text2-tipografia-govco table__styles__column--title">
              {{ 'paginacion.acciones' | translate }}
            </p>
          </th>
        </tr>
      </thead>
      <tbody class="contenido-tablas">
        <tr
          *ngIf="
            localFiltering ? datosFiltrados.length === 0 : datos.length === 0
          ">
          <td
            style="text-align: center !important"
            [attr.colspan]="
              columnasVisibles().length + (acciones.length > 0 ? 1 : 0)
            ">
            {{ 'paginacion.sin-registros' | translate }}
          </td>
        </tr>
        <tr
          *ngFor="
            let item of localFiltering ? datosFiltrados : datos;
            let i = index
          "
          (click)="clickeableRow ? accionCall('rowClick', item, i) : null"
          (keydown)="clickeableRow ? accionCall('rowClick', item, i) : null">
          <td class="text-center" *ngIf="multipleSelection">
            <input
              type="checkbox"
              [checked]="isSelected(item)"
              (change)="toggleSelection(item)" />
          </td>
          <td
            class="textBody"
            [ngClass]="{
              'text-end': value.type === 'number',
              'text-start': value.type !== 'number',
            }"
            *ngFor="let value of columnasVisibles()">
            <img [src]="item[value.field]" *ngIf="value.type === 'image'" alt="imagen"
                 [width]="value.widthImage" [height]="value.heightImage">
            <ng-select
              *ngIf="value.type === 'inputselect' && value.accion && value.enabledAction"
              [items]="value.elements ?? []"
              [bindLabel]="value.option || 'nombre'"
              [bindValue]="value.value || 'id'"
              [(ngModel)]="item[value.field]"
              [disabled]="item[value.enabledAction] || false"
              [searchable]="true"
              [required]="value.validations?.required ?? false"
              placeholder="{{ 'seleccione' | translate }}"
              (change)="value.accion(item)">
            </ng-select>

            <input
              [type]="value.inputType || 'text'"
              class="form-control select-custom"
              *ngIf="value.type === 'input' && value.accion"
              [(ngModel)]="item[value.field]"
              (blur)="value.accion(item)"
              min="{{ value.validations?.min ?? null }}"
              max="{{ value.validations?.max ?? null }}"
              [pattern]="value.validations?.pattern ?? '.*'"
              [required]="value.validations?.required ?? false"
              [minLength]="value.validations?.minLength ?? null"
              [maxLength]="value.validations?.maxLength ?? null" />
            <button
              (click)="value.accion(item)"
              class="link-tipografia-govco hvr-shrink btn-reset"
              *ngIf="value.accion && !value.type?.startsWith('input')
                    && !value.type?.startsWith('image')">
              <div
                class="d-flex flex-row"
                [ngClass]="{
                  'align-items-end': value.type === 'number',
                  'align-items-start': value.type !== 'number',
                }"
                [ngStyle]="value.type === 'number' ? { 'margin-right': '2rem' } : {}"
                >
                <span class="govco-folder-1 ml-1"></span>
                <p
                  class="m-0 text3-tipografia-govco"
                  *ngIf="value.pipe && value.type === 'date'">
                  {{ getValor(value, item) | date: value.pipe : 'GMT' }}
                </p>
                <p
                  class="m-0 text3-tipografia-govco"
                  *ngIf="value.pipe && value.type === 'number'">
                  {{ getValor(value, item) | number: value.pipe }}
                </p>
                <p class="m-0 text3-tipografia-govco" *ngIf="!value.pipe">
                  {{ getValor(value, item) }}
                </p>
              </div>
            </button>
            <ng-container *ngIf="!value.accion">
              <p
                class="m-0 text3-tipografia-govco"
                *ngIf="value.pipe && value.type === 'date'">
                {{ getValor(value, item) | date: value.pipe : 'GMT' }}
              </p>
              <p
                class="m-0 text3-tipografia-govco"
                *ngIf="value.pipe && value.type === 'number'">
                {{ getValor(value, item) | number: value.pipe }}
              </p>
              <p
                [ngStyle]="value.type === 'number' ? { 'margin-right': '2rem' } : {}"
                [ngClass]="{ 'm-0': value.type !== 'number' }"
                class="text3-tipografia-govco"
                *ngIf="!value.pipe && value.type !== 'html'&& value.type !== 'image'">
                {{ getValor(value, item) }}
              </p>
              <div
                *ngIf="value.type === 'html'"
                [innerHTML]="getValor(value, item)"></div>
            </ng-container>
          </td>
          <td class="td-actions text-center" *ngIf="acciones.length > 0">
            <div class="btn-group">
              <ng-container *ngFor="let accion of acciones; let j = index">
                <button
                  type="button"
                  *ngIf="accion.type === 'link'"
                  class="btn btn-actions btn-just-icon p-0 mx-1 btn-sm hvr-shrink"
                  style="color: #757575"
                  [routerLink]="
                    accion?.params
                      ? [accion.link, getLinkParams(accion.params, item)]
                      : [accion.link]
                  "
                  data-bs-toggle="tooltip"
                  [title]="accion.title"
                  [attr.aria-label]="'{{ accion.title }}'">
                  <i class="fa fa-{{ accion.icon }} fa-lg"></i>
                </button>
                <button
                  type="button"
                  *ngIf="accion.type === 'button' && (!accion.visible || accion.visible(item))"
                  class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink"
                  style="color: #757575"
                  (click)="accionCall(accion.idAccion, item, i)"
                  data-bs-toggle="tooltip"
                  [title]="accion.title"
                  [attr.aria-label]="'{{ accion.title }}'">
                  <i class="fa fa-{{ accion.icon }} fa-lg"></i>
                </button>
                <div class="form-check ms-1" *ngIf="accion.type === 'check'">
                  <label for="">{{accion.title}}</label>
                  <input
                    [id]="'item-' + i + '-' + 'j'"
                    class="form-check-input"
                    type="checkbox"
                    [value]="item[accion.selectField || 'checked']"
                    (click)="accionCall(accion.idAccion, item, i)"
                    [checked]="item[accion.selectField || 'checked']"
                    (keydown)="accionCall(accion.idAccion, item, i)" />
                </div>
                <div class="form-check ms-1" *ngIf="accion.type === 'select'">
                  <select
                    class="form-select select-custom"
                    (change)="accionCall(accion.idAccion, item, i)"
                    [disabled]="item || false">
                    <option [value]="undefined" selected>
                      {{ 'seleccione' | translate }}
                    </option>
                    <option
                      *ngFor="let opt of accion.elements"
                      [value]="opt[accion.value || 'id']">
                      {{ opt[accion.option || 'nombre'] }}
                    </option>
                  </select>
                </div>
                <button
                  type="button"
                  *ngIf="
                    accion.type === 'switch' &&
                    item[accion.switchField || 'estadoRegistro']
                  "
                  class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink"
                  (click)="accionCall(accion.idAccion, item, i)"
                  data-bs-toggle="tooltip"
                  [title]="accion.title"
                  [attr.aria-label]="'{{ accion.title }}'">
                  <i class="fa fa-toggle-on fa-lg"></i>
                </button>
                <button
                  type="button"
                  *ngIf="
                    accion.type === 'switch' &&
                    !item[accion.switchField || 'estadoRegistro']
                  "
                  class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink"
                  (click)="accionCall(accion.idAccion, item, i)"
                  data-bs-toggle="tooltip"
                  [title]="accion.title"
                  [attr.aria-label]="'{{ accion.title }}'">
                  <i class="fa fa-toggle-off fa-lg"></i>
                </button>
              </ng-container>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container mt-4" *ngIf="paginacion">
    <div
      id="pagination"
      class="row justify-content-center justify-content-xl-end align-items-center">
      <div class="col-12 col-xl-6">
        <ul
          class="pagination mb-5 mb-xl-0 justify-content-center justify-content-xl-end align-items-center">
          <li
            class="page-item btn-pagination-left"
            [ngClass]="{ disabled: paginaActual === 1 }">
            <button
              type="button"
              class="page-link pointer link-tipografia-govco"
              (click)="selectPage(paginaActual - 1)"
              aria-label="Previous"
              [disabled]="paginaActual === 1">
              {{ 'paginacion.anterior' | translate }}
            </button>
          </li>
          <li
            class="page-item btn-pagination-data"
            *ngFor="let page of pages(); let i = index"
            [ngClass]="{ active: page === paginaActual }">
            <a
              class="page-link pointer link-tipografia-govco ms-0"
              href="#"
              role="button"
              tabindex="0"
              (click)="selectPage(page, i); $event.preventDefault()"
              (keyup)="selectPage(page, i)"
              (keydown.enter)="selectPage(page, i)"
              (keydown.space)="selectPage(page, i)"
              [attr.aria-label]="'Ir a la página ' + page">
              {{ page }}
            </a>
          </li>
          <li
            class="page-item btn-pagination-right"
            [ngClass]="{
              disabled: totalPaginas === paginaActual || totalPaginas <= 1,
            }">
            <button
              type="button"
              class="page-link pointer link-tipografia-govco"
              (click)="selectPage(paginaActual + 1)"
              [disabled]="totalPaginas === paginaActual || totalPaginas <= 1"
              aria-label="Next">
              {{ 'paginacion.siguiente' | translate }}
            </button>
          </li>
        </ul>
      </div>
      <!--       <div class="col-2 col-xl-1 pe-2 px-xl-2">
        <input
          class="form-control NumberPaginador select-custom"
          type="number"
          placeholder="#"
          min="1"
          (keyup)="validatePage()"
          oncopy="return false"
          onpaste="return false"
          [max]="totalPaginas"
          [(ngModel)]="selectedPage" />
      </div>
      <div class="col-4 col-xl-1 px-0">
        <button
          type="button"
          [disabled]="!isPage"
          class="btn-govco outline-btn hvr-grow px-4 w-100"
          (click)="selectPage(selectedPage)">
          Ir a
        </button>
      </div> -->
    </div>
  </div>
</div>
